import { useList } from '../../../../../../../api/react-query';

export function useNoticePeriodAutomationStatus(params = {}) {
  const {
    data,
    isLoading,
    error,
    refetch
  } = useList(
    'config/company/noticePeriod-auto/status',
    { ...params },
    '',
  )
console.log(data?.data)
  return {
    noticePeriodAutomationStatus: data?.data?.data,
    noticePeriodAutomationStatusLoading: isLoading,
    noticePeriodAutomationError: error,
    refetch
  };
}
